import React from 'react';
import './index.scss';

const SpInputTitleMessage = ({ title, message, children }) =>{
  const DispTitle = () => {
    return Array.isArray(title) 
      ? title.map(line => (
        <span key={line} className="">
          {line}
          <br />
        </span>
      ))
      : <>{title}</>;
  };

  return (
    <div className="SpInputTitleMessage">
      <div className="SITM-title"> 
        <DispTitle />
        <div className="attention">
          {message}
        </div>
      </div>
      <span className="SITM-item">
        {children}
      </span>
    </div>
  );
};

export default SpInputTitleMessage;